import React from 'react'
import ServiceManagement from '../components/ServiceManagement/ServiceManagement'

const ServiceManagementPage = () => {
  return <ServiceManagement />
}

export default ServiceManagementPage
